var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWashmash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#999999",
    stroke: "#999999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 5.12
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#999999;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.385,0v512H51.2h409.6h11.816v-11.815V0H39.385z M448.985,488.369H63.015V116.585h385.969V488.369z M448.985,100.831H63.015v-77.2h385.969V100.831z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,410.792c70.696-0.008,127.996-57.3,128-128c-0.004-70.7-57.304-127.993-128-128 c-70.696,0.007-127.996,57.3-128,128C128.004,353.493,185.304,410.785,256,410.792z M176.631,203.415 c20.335-20.323,48.346-32.862,79.369-32.869c31.02,0.007,59.03,12.546,79.37,32.869c20.326,20.339,32.873,48.354,32.877,79.377 c-0.004,31.023-12.55,59.031-32.877,79.369c-20.339,20.323-48.346,32.87-79.37,32.878c-31.023-0.008-59.034-12.554-79.369-32.878 c-20.326-20.338-32.873-48.346-32.877-79.369C143.758,251.769,156.304,223.754,176.631,203.415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,374.138c50.454-0.007,91.35-40.892,91.354-91.353c-0.008-50.446-40.9-91.346-91.354-91.354 c-50.454,0.008-91.346,40.908-91.354,91.354C164.65,333.246,205.546,374.131,256,374.138z M202.542,229.331 c13.708-13.7,32.558-22.147,53.458-22.147c20.9,0,39.75,8.446,53.458,22.147c13.692,13.707,22.139,32.561,22.143,53.454 c-0.004,20.9-8.45,39.754-22.143,53.461C295.75,349.939,276.9,358.377,256,358.384c-20.9-0.007-39.75-8.446-53.458-22.138 c-13.692-13.707-22.139-32.562-22.143-53.461C180.403,261.892,188.85,243.038,202.542,229.331z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 323.938,
    cy: 58.092,
    r: 13.785
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 386.954,
    cy: 58.092,
    r: 13.785
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashmash);
export default __webpack_public_path__ + "static/media/washmash.61614e28e4851ec607883f47eedd47e8.svg";
export { ForwardRef as ReactComponent };